@if (isLoading) {
  <div class='sideBarContent content loading-spinner'></div>
}
@if (!isLoading) {
  <div class="sideBarContent content">
    <irb-editor-sidebar-banner
      [accordian]="accordian"
      [showUnsavedChangesWarning]="showUnsavedChangesWarning"
      [isModified]="isModified"
      [isValid]="isValid"
      [hasPendingFunction]="hasPendingFunction"
      [slot]="slot"
      (save)="save()"
      (cancel)="cancel()"><span header class="ms-header" tooltip [tooltipTitle]="'Edit Portfolio'" [tooltipRequiresTruncation]="true">Edit Portfolio</span></irb-editor-sidebar-banner>
      <div class="body" [style.height]="bodyHeight" #body>
        @if (data.isAutoRebalEnabled && selectedModel.allowAutoRebalOnModelUpdate === 'Paused for review') {
          <div class="block  status-message-model warning">
            <div style="padding-top:10px;">
              The assigned model has been changed by the model provider. Automated rebalancing will be paused until you review and resume rebalancing or assign this portfolio to a different model.
            </div>
            <div style="padding-top:10px;padding-bottom:10px;">
              <a class="nav-link-text" (click)="viewPortfolioModel()">Go to Model <fa-icon [icon]="faChevronRight" class="chevron"></fa-icon></a>
            </div>
          </div>
        }
        @if (data.isAutoRebalEnabled && selectedModel.allowAutoRebalOnModelUpdate === 'Not allowed') {
          <div class="block  status-message-model warning">
            <div style="padding-top:10px;">
              The assigned model does not currently allow automated rebalancing. You'll need to edit the model settings to allow automated rebalancing with this model.
            </div>
            <div style="padding-top:10px;padding-bottom:10px;">
              <a class="nav-link-text" (click)="viewPortfolioModel()">Go to Model <fa-icon [icon]="faChevronRight" class="chevron"></fa-icon></a>
            </div>
          </div>
        }
        <div class="block editorDisplayBanner">
          <div class="left editorDispalybannerHeader" style="width: 255px">
            <div class="editorDispalybannerText">
              @if (!isUnAuthorized) {
                <p #portfolioName>Portfolio Name | <strong><a id="editLink" (click)="showInlineEdit()">edit</a></strong></p>
              }
              @if (isUnAuthorized) {
                <p #portfolioName>Portfolio Name</p>
              }
            </div>
            @if (!showInLineeditFlag) {
              <span
                class="editorDispalyValueText portfolio-name-truncate"
                tooltip
                [tooltipTitle]="data.portfolioName"
                [tooltipRequiresTruncation]="true"
                tooltipPosition="bottom">
                {{data.portfolioName}}
              </span>
            }
            @if (showInLineeditFlag) {
              <irb-com-inlineedit [(tooltipMessage)]="tooltipMessage"
                defaultTooltip="Please provide valid portfolio name."
                [(data)]="data.portfolioName"
                [maxlength]="70"
                (save)="saveInlineEdit($event)"
                (close)="closeInlineEdit()"
                (change)="onTextChange()"
                [allowSpecialCharacters]="false"
                [customValidationFunction]="validatePortfolioName"
                [customValidationOverride]="true"
              ></irb-com-inlineedit>
            }
            <!-- <input type="text" pInputText class="portfolioName" style="min-width: 230px"> -->
          </div>
          <div class="left editorDispalybannerHeader">
            <div class="editorDispalybannerText"><p #portfolioID>ID</p></div>
            <span class="editorDispalyValueText">{{data.portfolioId}}</span>
          </div>
          <div class="left editorDispalybannerHeader">
            <div class="editorDispalybannerText"><p #dateCreate>Date Created / By</p></div>
            @if (data.createdDate!=null) {
              <span  class="editorDispalyValueText">{{data.createdDate | easternTime | date:'MM/dd/yyyy h:mm a'}} ET</span>
            }
            <div>{{data.createdBy}}</div>
          </div>
          <div class="left editorDispalybannerHeader">
            <div class="editorDispalybannerText"><p #lastEdit>Date Last Edited / By</p></div>
            @if (data.modifiedDate!=null) {
              <span class="editorDispalyValueText">{{data.modifiedDate | easternTime | date:'MM/dd/yyyy h:mm a'}} ET</span>
            }
            <div>{{data.modifiedBy}}</div>
          </div>
          <div class="left editorDispalybannerHeader">
            <div  class="editorDispalybannerText"><p #mktValue>Market Value</p></div>
            <span class="editorDispalyValueText">{{data.totalPortfolioValue | currency:'USD'}}</span>
          </div>
          <br class="clear"/>
        </div>
        @if (isUnAuthorized) {
          <div class="block editorDisplayBannerInfo">
            <div class="editorDispalybannerText">Your User ID does not have access to all accounts assigned to this Portfolio.</div>
            <div class="editorDispalyValueText">
              If you wish to manage this Portfolio, you must remove the accounts not assigned to your User ID.
              <br>
                Please contact your FSA or iRebal support team to correct your user configuration at 855-640-2472.
              </div>
            </div>
          }
          <mat-accordion #accordian="matAccordion" [multi]="true" >
            <mat-expansion-panel id="PORTFOLIO_HISTORY" [expanded]="localEditorsService.getDefaultExpansionState('PORTFOLIO_HISTORY')"
              (opened)="collapseForOpenTriggers? localEditorsService.updateExpansionStateOpenTriggers('PORTFOLIO_HISTORY','opened') : localEditorsService.updateExpansionState('PORTFOLIO_HISTORY','opened')"
              (closed)="collapseForOpenTriggers? localEditorsService.updateExpansionStateOpenTriggers('PORTFOLIO_HISTORY','closed') : localEditorsService.updateExpansionState('PORTFOLIO_HISTORY','closed')">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Portfolio History
                </mat-panel-title>
              </mat-expansion-panel-header>
              <ng-template matExpansionPanelContent>
                <irb-com-portfolio-history [portfolioId]="portfolioId"></irb-com-portfolio-history>
              </ng-template>
            </mat-expansion-panel>
            <mat-expansion-panel id="ACCOUNTS" [expanded]="localEditorsService.getDefaultExpansionState('ACCOUNTS')"
              (opened)="collapseForOpenTriggers? localEditorsService.updateExpansionStateOpenTriggers('ACCOUNTS','opened') : localEditorsService.updateExpansionState('ACCOUNTS','opened')"
              (closed)="collapseForOpenTriggers? localEditorsService.updateExpansionStateOpenTriggers('ACCOUNTS','closed') : localEditorsService.updateExpansionState('ACCOUNTS','closed')">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Accounts
                </mat-panel-title>
              </mat-expansion-panel-header>
              <ng-template matExpansionPanelContent >
                @if (data && isGlobalSettings) {
                  <irb-com-accounts #assignedAccounts [(data)]="data" [globalSettings]="globalSettings" (change)="onInputChange()"></irb-com-accounts>
                }
              </ng-template>
            </mat-expansion-panel>
            @if (!isUnAuthorized) {
              <mat-expansion-panel id="SETTINGS" [expanded]="localEditorsService.getDefaultExpansionState('SETTINGS')"
                (opened)="collapseForOpenTriggers? localEditorsService.updateExpansionStateOpenTriggers('SETTINGS','opened') : localEditorsService.updateExpansionState('SETTINGS','opened')"
                (closed)="collapseForOpenTriggers? localEditorsService.updateExpansionStateOpenTriggers('SETTINGS','closed') : localEditorsService.updateExpansionState('SETTINGS','closed')">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    Model Assignments @if (data.isAutoRebalEnabled && selectedModel?.allowAutoRebalOnModelUpdate === 'Paused for review') {
                    <img
                      class="quick-icons" src="../../../assets/images/warning-icon-amber.svg" style="margin-left: 12px;">
                    }
                  </mat-panel-title>
                </mat-expansion-panel-header>
                @if (data) {
                  <irb-com-assignments [(data)]="data" [parentObj]="this"
                    [selectedModel]="selectedModel"
                    (selectedModelChange)="onSelectedModelChange($event)"
                  (change)="onInputChange()"></irb-com-assignments>
                }
              </mat-expansion-panel>
            }
            @if (!isUnAuthorized) {
              <mat-expansion-panel id="CUSTOM_LABELS" [expanded]="localEditorsService.getDefaultExpansionState('CUSTOM_LABELS')"
                (opened)="collapseForOpenTriggers? localEditorsService.updateExpansionStateOpenTriggers('CUSTOM_LABELS','opened') : localEditorsService.updateExpansionState('CUSTOM_LABELS','opened')"
                (closed)="collapseForOpenTriggers? localEditorsService.updateExpansionStateOpenTriggers('CUSTOM_LABELS','closed') : localEditorsService.updateExpansionState('CUSTOM_LABELS','closed')">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Custom Labels
                </mat-panel-title>
              </mat-expansion-panel-header>
              <ng-template matExpansionPanelContent>
                @if (data && isGlobalSettings) {
                  <irb-com-custom-labels [(data)]="data" [globalSettings]="globalSettings" (change)="onInputChange()"></irb-com-custom-labels>
                }
              </ng-template>
            </mat-expansion-panel>
          }
          @if (!isUnAuthorized) {
            <mat-expansion-panel id="SECURITY_RESTRICTIONS" [expanded]="localEditorsService.getDefaultExpansionState('SECURITY_RESTRICTIONS')"
              (opened)="collapseForOpenTriggers? localEditorsService.updateExpansionStateOpenTriggers('SECURITY_RESTRICTIONS','opened') : localEditorsService.updateExpansionState('SECURITY_RESTRICTIONS','opened')"
              (closed)="collapseForOpenTriggers? localEditorsService.updateExpansionStateOpenTriggers('SECURITY_RESTRICTIONS','closed') : localEditorsService.updateExpansionState('SECURITY_RESTRICTIONS','closed')">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Security Restrictions
                </mat-panel-title>
              </mat-expansion-panel-header>
              <ng-template matExpansionPanelContent>
                @if (data && isGlobalSettings) {
                  <irb-com-restrictions [(data)]="data" [globalSettings]="globalSettings" [(isValid)]="isSecurityRestrictionsValid" (change)="onInputChange()"></irb-com-restrictions>
                }
              </ng-template>
            </mat-expansion-panel>
          }
          @if (isPortfEqvEnabled) {
            <mat-expansion-panel  id="EQUIVALENTS_ALTERNATIVES" [expanded]="localEditorsService.getDefaultExpansionState('EQUIVALENTS_ALTERNATIVES')"
              (opened)="collapseForOpenTriggers? localEditorsService.updateExpansionStateOpenTriggers('EQUIVALENTS_ALTERNATIVES','opened') : localEditorsService.updateExpansionState('EQUIVALENTS_ALTERNATIVES','opened')"
              (closed)="collapseForOpenTriggers? localEditorsService.updateExpansionStateOpenTriggers('EQUIVALENTS_ALTERNATIVES','closed') : localEditorsService.updateExpansionState('EQUIVALENTS_ALTERNATIVES','closed')">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Equivalents
                </mat-panel-title>
              </mat-expansion-panel-header>
              @if (!isUiTest) {
                <div>
                  @if (data) {
                    <irb-portfolio-equivalents-alternatives [data]="data" (change)="onInputChange()"
                    (viewPortfolioModelOut)="viewPortfolioModel()"></irb-portfolio-equivalents-alternatives>
                  }
                </div>
              }
            </mat-expansion-panel>
          }
          @if (!isUnAuthorized) {
            <mat-expansion-panel id="GAINS_MANAGEMENT" [expanded]="localEditorsService.getDefaultExpansionState('GAINS_MANAGEMENT')"
              (opened)="collapseForOpenTriggers? localEditorsService.updateExpansionStateOpenTriggers('GAINS_MANAGEMENT','opened') : localEditorsService.updateExpansionState('GAINS_MANAGEMENT','opened')"
              (closed)="collapseForOpenTriggers? localEditorsService.updateExpansionStateOpenTriggers('GAINS_MANAGEMENT','closed') : localEditorsService.updateExpansionState('GAINS_MANAGEMENT','closed')">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Gains Management
                </mat-panel-title>
              </mat-expansion-panel-header>
              <ng-template matExpansionPanelContent>
                @if (data && isGlobalSettings) {
                  <irb-com-gains [(data)]="data" [globalSettings]="globalSettings" [(isValid)]="isGainsManagementValid" (change)="onInputChange()"></irb-com-gains>
                }
              </ng-template>
            </mat-expansion-panel>
          }
          @if (!isUnAuthorized  && isAutoRebalanceEnabled) {
            <mat-expansion-panel id="AUTOMATED_REBALANCING" [expanded]="localEditorsService.getDefaultExpansionState('AUTOMATED_REBALANCING')"
              (opened)="collapseForOpenTriggers? localEditorsService.updateExpansionStateOpenTriggers('AUTOMATED_REBALANCING','opened') : localEditorsService.updateExpansionState('AUTOMATED_REBALANCING','opened')"
              (closed)="collapseForOpenTriggers? localEditorsService.updateExpansionStateOpenTriggers('AUTOMATED_REBALANCING','closed') : localEditorsService.updateExpansionState('AUTOMATED_REBALANCING','closed')">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Automated Rebalancing @if (data.isAutoRebalEnabled && (selectedModel?.allowAutoRebalOnModelUpdate === 'Paused for review' || selectedModel?.allowAutoRebalOnModelUpdate === 'Not allowed')) {
                  <img
                    class="quick-icons" src="../../../assets/images/warning-icon-amber.svg" style="margin-left: 12px;">
                  }
                </mat-panel-title>
              </mat-expansion-panel-header>
              <ng-template matExpansionPanelContent>
                @if (data) {
                  <irb-com-automated-rebalancing [(data)]="data"
                    [selectedModel]="selectedModel"
                  [isTLHSetInGlobal]="isTLHSetInGlobal" (change)="onInputChange()"></irb-com-automated-rebalancing>
                }
              </ng-template>
            </mat-expansion-panel>
          }
          @if (!isUnAuthorized) {
            <mat-expansion-panel id="SCHEDULED_REBALANCES_LIST" [expanded]="localEditorsService.getDefaultExpansionState('SCHEDULED_REBALANCES_LIST')"
              (opened)="collapseForOpenTriggers? localEditorsService.updateExpansionStateOpenTriggers('SCHEDULED_REBALANCES_LIST','opened') : localEditorsService.updateExpansionState('SCHEDULED_REBALANCES_LIST','opened')"
              (closed)="collapseForOpenTriggers? localEditorsService.updateExpansionStateOpenTriggers('SCHEDULED_REBALANCES_LIST','closed') : localEditorsService.updateExpansionState('SCHEDULED_REBALANCES_LIST','closed')">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Scheduled Rebalances
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              @if (data) {
                <irb-com-scheduled-rebalances-list [(data)]="data" (change)="onInputChange()"></irb-com-scheduled-rebalances-list>
              }
            </ng-template>
          </mat-expansion-panel>
        }
        @if (!isUnAuthorized) {
          <mat-expansion-panel id="PORTFOLIO_NOTES" [expanded]="localEditorsService.getDefaultExpansionState('PORTFOLIO_NOTES')"
            (opened)="collapseForOpenTriggers? localEditorsService.updateExpansionStateOpenTriggers('PORTFOLIO_NOTES','opened') : localEditorsService.updateExpansionState('PORTFOLIO_NOTES','opened')"
            (closed)="collapseForOpenTriggers? localEditorsService.updateExpansionStateOpenTriggers('PORTFOLIO_NOTES','closed') : localEditorsService.updateExpansionState('PORTFOLIO_NOTES','closed')">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Portfolio Notes
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              @if (data) {
                <irb-com-portfolio-notes #listOfNotes [(data)]="data.listOfNotes" (change)="onInputChange()"></irb-com-portfolio-notes>
              }
            </ng-template>
          </mat-expansion-panel>
        }
      </mat-accordion>
    </div>
  </div>
}
